import { Box, CircularProgress } from "@mui/material";

export const Loading = ({ message }) => (
    <Box
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
        <CircularProgress style={{ margin: "15px" }} />
        { message ? message : "Cargando Información" }
    </Box>
);
